import { UseFormReturn } from 'react-hook-form';

export type ApiError = {
  message: string;
  /** Например, для UI повторной отправки письма подтверждения */
  code?: string;
  formErrors: {
    field: string;
    message: string;
  }[];
};

export function setFormErrorsFromApi(
  form: UseFormReturn<any>,
  error: ApiError,
) {
  error?.formErrors.forEach((formError) => {
    form.setError(formError.field, {
      message: formError.message,
    });
  });
}
